<template>
  <div class="suc_box">
    <StepBar :step="2"></StepBar>
    <h5 class="large_title">注册成功</h5>
    <p class="sub_title">完善信息即可投放广告</p>
    <ad-button class="info_btn" @click="goAccountPage">完善信息</ad-button>
    <div class="img_ctn">
      <div class="code_img">
        <div class="half">
          <img :src="qrAdr" alt="Android二维码">
          下载 Android App
        </div>
        <div class="half">
          <img :src="qrIos" alt="iOS二维码">
          下载 Android App
        </div>
      </div>
      <p class="txt_1">欢迎下载梯之星APP</p>
      <p class="txt_2">https://adv.yun-ti.com</p>
    </div>
  </div>
</template>

<script type="text/javascript">
import StepBar from '@/components/TheLogonStepBar'
import qrAdr from '@/assets/qrAndroid.png'
import qrIos from '@/assets/qrIos.png'

export default {
  name: 'RegistSuccess',
  components: { StepBar },
  data () {
    return {
      qrAdr,
      qrIos
    }
  },
  methods: {
    goAccountPage () {
      this.goUrl('/accountInfo')
    }
  }
}
</script>

<style lang="sass" scoped>
.suc_box
  padding-top: 50px
.large_title
  margin: 50px auto 6px
  color: #282729
  font-size: 28px
  line-height: 40px
  font-weight: 600
  text-align: center
.sub_title
  margin-bottom: 20px
  color: #999
  font-size: 16px
  line-height: 22px
  text-align: center
.info_btn
  margin-top: 30px !important
.img_ctn
  margin: 0 -200px
  text-align: center
.code_img
  display: inline-block
  margin-bottom: 20px
  .half
    width: 50%
    float: left
    text-align: center
    img
      display: block
      margin: 20px 20px 10px
      width: 200px
.txt_1 
  text-align: center
  color: #282729
  font-size: 16px
  line-height: 22px
.txt_2
  text-align: center
  margin-top: 8px
  color: #999999
  font-size: 14px
  line-height: 20px
// .hide
//   display: none
</style>